export const locally = {
    develop: false
};